import React from 'react';
import { TileToolbar } from 'widgets/tiles/components/tile/TileToolbar';
import { WidgetTile } from 'widgets/tiles/components/tile/WidgetTile';
import classNames from 'classnames';

import { useOrderLiquidityCapsuleConfigSlice } from 'widgets/venueAnalysis/capsules/orderLiquidityCapsule/store/configslice.ts';
import { liquiditySummaryCapsuleStreamedDataSelectors } from 'widgets/venueAnalysis/capsules/orderLiquidityCapsule/store/streamSlice.ts';
import { useWarningForOrderDependentCapsulesSupportingSymbolQuantity } from 'widgets/tiles/components/tile/hooks.ts';
import { getVenueAnalysisData } from 'widgets/venueAnalysis/venueAnalysisAggregatedData';
import useWidgetStream from 'widgets/streaming/useWidgetStream.ts';
import OrderLiquidityCapsuleSettings from 'widgets/venueAnalysis/capsules/orderLiquidityCapsule/components/OrderLiquidityCapsuleSettings.tsx';
import InfoBox from 'utils/components/InfoBox/InfoBox.tsx';
import { OrderLiquidityCapsuleContent } from 'widgets/venueAnalysis/capsules/orderLiquidityCapsule/components/OrderLiquidityCapsuleContent.tsx';
import OrderLiquidityCapsuleChartHelp from 'widgets/venueAnalysis/capsules/orderLiquidityCapsule/components/OrderLiquidityCapsuleChartHelp.tsx';

export function OrderLiquidityCapsule() {
    useWidgetStream();

    const { config } = useOrderLiquidityCapsuleConfigSlice();

    const { useWidgetStreamData, useWidgetMessages } =
        liquiditySummaryCapsuleStreamedDataSelectors;
    const streamData = useWidgetStreamData();
    const messages = useWidgetMessages();

    const data = getVenueAnalysisData(
        streamData,
        undefined,
        config.includePreviousDaysFills
    );

    const warning =
        useWarningForOrderDependentCapsulesSupportingSymbolQuantity();

    const cssClasses = classNames('OrderLiquidityCapsule');

    return (
        <WidgetTile className={cssClasses}>
            <TileToolbar
                title="Order Liquidity"
                settingsBody={<OrderLiquidityCapsuleSettings />}
                preceedingItems={<OrderLiquidityCapsuleChartHelp />}
                messages={messages}
                wideTitle={true}
            />

            <div className="capsule-body">
                {warning && <InfoBox info={warning} />}
                {!warning && !data && <>No data</>}
                {!warning && data && (
                    <OrderLiquidityCapsuleContent data={data} />
                )}
            </div>
        </WidgetTile>
    );
}
